import { useId } from "react";

import "./Seal.css";

import type { SizeProp } from "../components";
import type { CSSProperties } from "react";

export interface SealProps {
  artwork?: Maybe<string>;
  size?: Extract<SizeProp, "sm" | "md" | "lg" | "xl">;
}

const sizeMap: Record<NonNullable<SealProps["size"]>, string> = {
  sm: "var(--size-4)",
  md: "var(--size-8)",
  lg: "var(--size-10)",
  xl: "var(--size-15)",
};

export function Seal({ artwork, size = "md" }: SealProps) {
  const id = useId();

  const customProperties = {
    "--size": sizeMap[size],
  } as CSSProperties;

  return (
    <div className="Seal" style={customProperties}>
      <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <clipPath id={id}>
          <path d="m335.5 64h64.5c26.5 0 48 21.49 48 48v64.5l45.6 45.6c18.7 18.7 18.7 49.1 0 67.8l-45.6 45.6v64.5c0 26.5-21.5 48-48 48h-64.5l-45.6 45.6c-18.7 18.7-49.1 18.7-67.8 0l-45.6-45.6h-64.5c-26.51 0-48-21.5-48-48v-64.5l-45.59-45.6c-18.7428-18.7-18.7428-49.1 0-67.8l45.59-45.6v-64.5c0-26.51 21.49-48 48-48h64.5l45.6-45.59c18.7-18.7409 49.1-18.7409 67.8 0z" />
        </clipPath>

        {artwork && (
          <image
            width="512"
            height="512"
            clipPath={`url(#${id})`}
            xlinkHref={artwork}
          />
        )}
      </svg>
    </div>
  );
}
